export default __webpack_public_path__ + "static/media/frame1b.a92a9276.PNG";